import { put, takeEvery, takeLatest, call } from 'redux-saga/effects';
import { deserializeKeys, serializeKeys } from '@iso/lib/helpers/keyNormalizer';
import request from '@iso/lib/helpers/httpClient';
import * as CONSTANTS from './constants';
import * as ACTIONS from './actions';

export function* fetchAccountJobs({ accountId }) {
  try {
    const data = yield call(request, `/user/${accountId}/job_memos/pending/`, 'GET');
    yield put(ACTIONS.fetchPendingMemosSuccess(serializeKeys(data)));
  } catch (error) {
    yield put(ACTIONS.fetchPendingMemosFail(error));
  }
}

export function* fetchAccountNetworkInvitations({ accountId, filter }) {
  try {
    const data = yield call(request, `/user/${accountId}/personal_network/received/`, 'GET', deserializeKeys(filter));
    yield put(ACTIONS.fetchAccountNetworkInvitationsSuccess(serializeKeys(data)));
  } catch (error) {
    yield put(ACTIONS.fetchAccountNetworkInvitationsFail(error));
  }
}

export default function* accountBoardSaga() {
  yield takeEvery(CONSTANTS.FETCH_PENDING_MEMOS_REQUEST, fetchAccountJobs);
  yield takeEvery(CONSTANTS.FETCH_ACCOUNT_NETWORK_INVITATIONS_REQUEST, fetchAccountNetworkInvitations);
}
